"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.genFakeTitle = exports.reset = exports.genFakeProjectName = exports.genFakeLike = exports.genFakeName_nonDeterministic = void 0;
var imports_1 = require("@lib/imports");
var generator_1 = require("@voyage/project-name-generator/generator");
// const fakerator = require('fakerator/locales/default')()
var fakerator = require('fakerator')();
var namespace = 'fakes';
function genFakeName_nonDeterministic() {
    // TODO: make our own that is deterministic?
    var name = fakerator.names.name();
    // console.log(namespace, name)
    return name;
}
exports.genFakeName_nonDeterministic = genFakeName_nonDeterministic;
// export function genFakeName(rando: IRandoInstanced) {
//   // TODO: make our own that is deterministic?
//   let name = fakerator.names.name()
//   // console.log(namespace, name)
//   return name
// }
var pets = [
    'rock',
    'book',
    'robot',
    'cat',
    'doggo',
    'frog',
    'lemon tree',
    'gila monster',
    'chicken',
    'rat',
];
var foods = [
    'pizza',
    'popcorn',
    'yogurt',
    'cheese',
    'kale',
    'sushi',
    'potato chips',
    'glue',
    'paste',
    'sausages',
];
function genFakeLike(rando) {
    var like = rando.sample(likes);
    // console.log(namespace, l)
    return like(rando);
}
exports.genFakeLike = genFakeLike;
function genFakePet1(rando) {
    return "Has a pet " + rando.sample(pets) + ".";
}
function genFakePet2(rando) {
    return "Keeps a " + rando.sample(pets) + " as a pet.";
}
function genFaveFood1(rando) {
    return "Likes to eat " + rando.sample(foods) + ".";
}
function genFaveFood2(rando) {
    return "Their favorite food is " + rando.sample(foods) + ".";
}
var likes = [genFakePet1, genFakePet2, genFaveFood1, genFaveFood2];
function genFakeProjectName(rando) {
    return generator_1.generate({ words: rando.i(2, 3) }).spaced;
}
exports.genFakeProjectName = genFakeProjectName;
var origTitles = [
    'Captain',
    'Doctor',
    'Number One',
    'Intern',
    'Lawyer',
    'Game Developer',
    'Cook',
    'Gunner',
    'Psychologist',
];
var titles = imports_1.l.cloneDeep(origTitles);
function reset() {
    titles = imports_1.l.cloneDeep(origTitles);
}
exports.reset = reset;
function genFakeTitle() {
    // TODO: this doesn't really work
    if (titles.length > 0) {
        return titles.shift() || 'Redshirt';
    }
    return 'Redshirt';
}
exports.genFakeTitle = genFakeTitle;
